import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=5c010480&scoped=true&"
import script from "./ExternalLink.vue?vue&type=script&lang=js&"
export * from "./ExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLink.vue?vue&type=style&index=0&id=5c010480&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c010480",
  null
  
)

export default component.exports